import { Directive, Input, } from '@angular/core';
import { mediaApi } from '@sitecore-jss/sitecore-jss/media';
import * as i0 from "@angular/core";
export class ImageDirective {
    viewContainer;
    templateRef;
    renderer;
    elementRef;
    field;
    editable = true;
    /**
     * Custom regexp that finds media URL prefix that will be replaced by `/-/jssmedia` or `/~/jssmedia`.
     * @example
     * /\/([-~]{1})assets\//i
     * /-assets/website -> /-/jssmedia/website
     * /~assets/website -> /~/jssmedia/website
     */
    mediaUrlPrefix;
    urlParams = {};
    attrs = {};
    inlineRef = null;
    constructor(viewContainer, templateRef, renderer, elementRef) {
        this.viewContainer = viewContainer;
        this.templateRef = templateRef;
        this.renderer = renderer;
        this.elementRef = elementRef;
    }
    ngOnChanges(changes) {
        if (changes.field || changes.editable || changes.urlParams || changes.attrs) {
            this.viewContainer.clear();
            if (this.inlineRef) {
                this.inlineRef.remove();
                this.inlineRef = null;
            }
            this.updateView();
        }
    }
    updateView() {
        const overrideAttrs = {
            ...this.getElementAttrs(),
            ...this.attrs,
        };
        const media = this.field;
        if (!media || (!media.editable && !media.value && !media.src)) {
            return;
        }
        let attrs = {};
        // we likely have an experience editor value, should be a string
        if (this.editable && media.editable) {
            const foundImg = mediaApi.findEditorImageTag(media.editable);
            if (!foundImg) {
                return this.renderInlineWrapper(media.editable);
            }
            attrs = this.getImageAttrs(foundImg.attrs, overrideAttrs, this.urlParams);
            if (!attrs) {
                return this.renderInlineWrapper(media.editable);
            }
            const tempImg = this.renderer.createElement('img');
            Object.entries(attrs).forEach(([key, attrValue]) => tempImg.setAttribute(key, attrValue));
            const editableMarkup = media.editable.replace(foundImg.imgTag, tempImg.outerHTML);
            return this.renderInlineWrapper(editableMarkup);
        }
        // some wise-guy/gal is passing in a 'raw' image object value
        const img = media.src ? media : media.value;
        if (!img) {
            return null;
        }
        attrs = this.getImageAttrs(img, overrideAttrs, this.urlParams);
        if (attrs) {
            this.renderTemplate(attrs);
        }
    }
    getImageAttrs(fieldAttrs, parsedAttrs, imageParams) {
        const combinedAttrs = {
            ...fieldAttrs,
            ...parsedAttrs,
        };
        // eslint-disable-next-line prefer-const
        let { src, srcSet, ...otherAttrs } = combinedAttrs;
        if (!src) {
            return null;
        }
        const newAttrs = {
            ...otherAttrs,
        };
        // update image URL for jss handler and image rendering params
        src = mediaApi.updateImageUrl(src, imageParams, this.mediaUrlPrefix);
        if (srcSet) {
            // replace with HTML-formatted srcset, including updated image URLs
            newAttrs.srcSet = mediaApi.getSrcSet(src, srcSet, imageParams, this.mediaUrlPrefix);
        }
        else {
            newAttrs.src = src;
        }
        return newAttrs;
    }
    renderTemplate(imageProps) {
        const viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
        viewRef.rootNodes.forEach((node) => {
            Object.entries(imageProps).forEach(([key, imgPropVal]) => this.renderer.setAttribute(node, key, imgPropVal));
        });
    }
    getElementAttrs() {
        const view = this.templateRef.createEmbeddedView(null);
        const element = view.rootNodes[0];
        if (!element) {
            view.destroy();
            return {};
        }
        const attrs = {};
        for (let i = 0; i < element.attributes.length; i++) {
            const attr = element.attributes.item(i);
            if (attr) {
                attrs[attr.name] = attr.value;
            }
        }
        view.destroy();
        return attrs;
    }
    renderInlineWrapper(editable) {
        const span = this.renderer.createElement('span');
        span.className = 'sc-image-wrapper';
        span.innerHTML = editable;
        const parentNode = this.renderer.parentNode(this.elementRef.nativeElement);
        this.renderer.insertBefore(parentNode, span, this.elementRef.nativeElement);
        parentNode.removeChild(this.elementRef.nativeElement);
        this.inlineRef = span;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ImageDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.TemplateRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: ImageDirective, selector: "[scImage]", inputs: { field: ["scImage", "field"], editable: ["scImageEditable", "editable"], mediaUrlPrefix: ["scImageMediaUrlPrefix", "mediaUrlPrefix"], urlParams: ["scImageUrlParams", "urlParams"], attrs: ["scImageAttrs", "attrs"] }, usesOnChanges: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ImageDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[scImage]' }]
        }], ctorParameters: () => [{ type: i0.ViewContainerRef }, { type: i0.TemplateRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }], propDecorators: { field: [{
                type: Input,
                args: ['scImage']
            }], editable: [{
                type: Input,
                args: ['scImageEditable']
            }], mediaUrlPrefix: [{
                type: Input,
                args: ['scImageMediaUrlPrefix']
            }], urlParams: [{
                type: Input,
                args: ['scImageUrlParams']
            }], attrs: [{
                type: Input,
                args: ['scImageAttrs']
            }] } });
